import React from "react";
import { motion } from "framer-motion";
import CountdownTimer from "./CountdownTimer";

const HERO_BG =
  "https://media.base44.com/images/public/69f76473804ed80bff201020/c56a862cb_generated_a021d837.png";
const BCS_LOGO =
  "https://media.base44.com/images/public/69f76473804ed80bff201020/39bd1f5d2_bcs_logo_crest.JPG";

export default function HeroSection() {
  return (
    <section
      className="relative overflow-hidden rounded-2xl"
      data-testid="hero-section"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{ backgroundImage: `url(${HERO_BG})` }}
      />
      <div className="absolute inset-0 bg-primary/80" />

      <div className="relative px-6 pt-10 pb-12 sm:px-10 sm:pt-12 sm:pb-16">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6 mb-8">
          <img
            src={BCS_LOGO}
            alt="BCS Logo"
            className="w-16 h-16 sm:w-20 sm:h-20 rounded-lg object-cover"
          />
          <CountdownTimer />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
        >
          <h1 className="font-display text-4xl md:text-6xl font-bold text-primary-foreground leading-tight mb-2">
            Nurture. Guide. Empower.
          </h1>
          <p className="text-primary-foreground/90 text-2xl md:text-3xl font-semibold mb-4">
            Conference
          </p>
        </motion.div>
      </div>
    </section>
  );
}
